<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <b-button
        type="button"
        class="back-btn flex items-center ml-3 mb-4"
        @click="showCorporatebooking"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          @click="showCorporatebooking"
          svgClasses=""
        />
        Back
      </b-button>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
          <div class="flex w-full justify-evenly">
            <div class="w-48">
              <base-input
                v-model="form.name"
                name="Company Name"
                :rules="{ required: true }"
              >
                <b-form-group
                  id="input-group-2"
                  label="Company Name:"
                  label-for="input-2"
                  class="mb-1"
                >
                  <b-form-input
                    id="input-2"
                    v-model="book_data.companyName"
                    placeholder="Enter Company Name"
                  >
                  </b-form-input> </b-form-group
              ></base-input>
            </div>

            <div class="w-48">
              <base-input
                v-model="form.email"
                name="Email"
                :rules="{ required: true, email: true }"
              >
                <b-form-group
                  id="input-group-1"
                  label="Email :"
                  label-for="input-1"
                  class="mb-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="book_data.email"
                    type="email"
                    placeholder="Enter email"
                  >
                  </b-form-input> </b-form-group
              ></base-input>
            </div>
          </div>

          <div class="flex justify-evenly w-full">
            <div class="w-48">
              <base-input
                v-model="form.mobileno"
                name="Mobile Number"
                :rules="{ required: true, numeric: true, min: 10, max: 10 }"
              >
                <b-form-group
                  id="input-group-2"
                  label="Enter Phone Number"
                  label-for="input-2"
                  class="mb-1"
                >
                  <b-form-input
                    v-model="book_data.mobileno"
                    placeholder="Enter your number"
                  ></b-form-input>
                </b-form-group>
              </base-input>
            </div>
            <div class="w-48">
              <base-input
                v-model="form.licenceno"
                name="No. of License"
                :rules="{ required: true, numeric: true }"
              >
                <b-form-group
                  id="input-group-2"
                  label="No. of License"
                  label-for="input-2"
                  class="mb-1"
                >
                  <b-form-input
                    v-model="book_data.licence"
                    placeholder="Types"
                  ></b-form-input>
                </b-form-group>
              </base-input>
            </div>
          </div>

          <div class="flex justify-evenly w-full">
            <div class="w-48">
              <base-input
                v-model="time1"
                name="Start Date"
                :rules="{ required: true }"
              >
                <b-form-group label="Start Date:" class="mb-1">
                  <date-picker
                    v-model="book_data.startDate"
                    class="w-full"
                    value-type="date"
                    :disabled-date="startDisableDate"
                    format="DD-MM-YYYY"
                    placeholder="Select Start Date"
                  ></date-picker> </b-form-group
              ></base-input>
            </div>

            <div class="w-48">
              <base-input
                v-model="time2"
                name="End Date"
                :rules="{ required: true }"
              >
                <b-form-group
                  id="input-group-2"
                  label="End Date:"
                  label-for="input-2"
                  class="mb-1"
                >
                  <date-picker
                    v-model="book_data.endDate"
                    class="w-full"
                    :disabled-date="endDisableDate"
                    format="DD-MM-YYYY"
                    value-type="date"
                    placeholder="Select End Date"
                  ></date-picker> </b-form-group
              ></base-input>
            </div>
          </div>

          <!-- 
      <label for="datepicker-valid">start date</label>
      <b-form-datepicker
        id="datepicker-valid"
        :state="true"
      ></b-form-datepicker> -->

          <!-- <div class="w-48 ml-3.5">
        <b-form-group id="input-group-3" label="Status:" label-for="input-3">
          <b-form-select
            id="input-3"
            aria-placeholder="type"
            v-model="book_data.status"
            :options="status"
            required
          >
          </b-form-select>
        </b-form-group>
      </div> -->

          <b-button type="submit" variant="primary" class="mx-auto flex mb-12"
            >Submit</b-button
          ></b-form
        >
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        value: "",
        status: "type",
      },
      time1: null,
      time2: null,
      status: ["Active ", "Pending", "On Hold", "Cancel"],
      flatdate: null,
      show: true,
      mobileno: "",
      pageData: {},
      book_data: {},
      prevLicence: 0,
    };
  },
  watch: {
    pageData(val) {
      this.book_data = {
        ...val,
        startDate: new Date(val.startDate),
        endDate: new Date(val.endDate),
      };
    },
  },

  methods: {
    endDisableDate(date) {
      if (this.book_data.startDate) {
        let newDate = new Date(date);
        return newDate <= new Date(this.book_data.startDate);
      }
    },
    startDisableDate(date) {
      if (this.book_data.endDate) {
        let newDate = new Date(date);
        return newDate >= new Date(this.book_data.endDate);
      }
    },
    async onSubmit(event) {
      //   event.preventDefault();
      //   alert(JSON.stringify(this.form));
      this.prevLicence = this.prevLicence + Number(this.book_data.licence);

      let payload = {
        _id: this.book_data._id,
        companyName: this.book_data.companyName,
        email: this.book_data.email,
        mobileno: this.book_data.mobileno.toString(),
        licence: this.book_data.licence.toString(),
        availableLicence: this.prevLicence.toString(),
        startDate: this.book_data.startDate,
        endDate: this.book_data.endDate,
        // status: this.book_data.status,
      };
      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch("corporate/edit", payload);
        if (editData.code == 200) {
          this.$router.push({ name: "admin-corporateBooking" });
          this.$swal.fire({
            text: "Booking details updated successfully!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      } catch (err) {
        if (err) {
          loader.close();
          this.$swal.fire({
            title: "Error",
            text: err.response.status === 409 ? err.response.data.message : "",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },

    showCorporatebooking() {
      this.$router.push({ name: "admin-corporateBooking" });
    },

    onReset(event) {
      event.preventDefault();
      this.form.name = "";
      this.form.email = "";
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    async init() {
      // console.log(this.selectBooking);
      this.pageData = this.selectBooking;
      this.prevLicence = this.selectBooking.availableLicence;
    },
  },
  computed: {
    ...mapState("corporate", {
      selectBooking: "selectBooking",
    }),
    // computedData:{
    //     get(){
    //         return this.data.mobile
    //     }
    // },
  },
  mounted() {
    this.init();
  },
  components: {
    DatePicker,
  },
};
</script>

<style>
.mx-calendar-content .cell:hover {
  color: white;
  background-color: #6c0b6b;
}
.mx-calendar-content .cell.active {
  color: white;
  background-color: #6c0b6b;
}
.back-btn {
  border: 1px solid black;
  padding: 4px 19px;
}
.border-box {
  border: 1px solid #ddd;
}
.fsize20px {
  font-size: 20px;
}
.w-48 {
  width: 48%;
}
.input-b {
  width: 100%;
  padding: 7px 2px 10px 4px;
}
form-btn .mt-3rem {
  margin-top: 3rem;
}
.justify-evenly {
  justify-content: space-evenly;
}
.mx-datepicker {
  width: 100% !important;
}
</style>
